export default __webpack_public_path__ + "static/media/CF10.e1d96058.jpg";